import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import {
  BoomTestimonial1Name,
  BoomTestimonial1Review,
  BoomTestimonial2Name,
  BoomTestimonial2Review,
  BoomTestimonial3Name,
  BoomTestimonial3Review,
  BoomTestimonial4Name,
  BoomTestimonial4Review,
  BoomTestimonial5Name,
  BoomTestimonial5Review,
  BoomTestimonial6Name,
  BoomTestimonial6Review,
  BoomTestimonial8Name,
  BoomTestimonial8Review,
  BoomTestimonial9Name,
  BoomTestimonial9Review,
  BoomTestimonial10Name,
  BoomTestimonial10Review,
  RoutineStick,
  BoomTagSports,
  BoomTagRecovery,
  BoomTagEnergy,
  BoomTagSleep,
  BoomTagFocus,
  BoomTagStress,
  BoomTagNails,
  BoomTagImmunity,
  BoomTagDigestion,
  BoomTagSachet,
  BoomTagConsistency,
} from '../../../Constants';
import Preview1 from '../../../assets/1-preview.webp';
import Preview3 from '../../../assets/3-preview.webp';
import Preview8 from '../../../assets/8-preview.webp';
import FabienneImg from '../../../assets/testimonials/Fabienne.webp';
import { Icon } from '../../elements/icon';
import SportsPerformance from '../../../assets/focusareas-green/sports-performance.svg';
import MusclePain from '../../../assets/focusareas-green/muscle-pain.svg';
import Energy from '../../../assets/focusareas-green/energy.svg';
import Sleep from '../../../assets/focusareas-green/sleep.svg';
import Focus from '../../../assets/focusareas-green/focus.svg';
import Stress from '../../../assets/focusareas-green/stress.svg';
import Nails from '../../../assets/focusareas-green/nail.svg';
import ImmuneSystem from '../../../assets/focusareas-green/immune-system.svg';
import Digestion from '../../../assets/focusareas-green/digestion.svg';

const getTagConfig = (t) => [
  {
    key: 'sports',
    label: t(BoomTagSports),
    icon: SportsPerformance,
    bg: 't-bg-green-100',
    border: 't-border-green-300',
  },
  {
    key: 'recovery',
    label: t(BoomTagRecovery),
    icon: MusclePain,
    bg: 't-bg-sky-100',
    border: 't-border-sky-300',
  },
  {
    key: 'energy',
    label: t(BoomTagEnergy),
    icon: Energy,
    bg: 't-bg-amber-100',
    border: 't-border-amber-300',
  },
  { key: 'sleep', label: t(BoomTagSleep), icon: Sleep, bg: 't-bg-sky-100', border: 't-border-sky-300' },
  { key: 'focus', label: t(BoomTagFocus), icon: Focus, bg: 't-bg-violet-100', border: 't-border-violet-300' },
  {
    key: 'stress',
    label: t(BoomTagStress),
    icon: Stress,
    bg: 't-bg-orange-100',
    border: 't-border-orange-300',
  },
  { key: 'nails', label: t(BoomTagNails), icon: Nails, bg: 't-bg-pink-100', border: 't-border-pink-300' },
  {
    key: 'immunity',
    label: t(BoomTagImmunity),
    icon: ImmuneSystem,
    bg: 't-bg-red-100',
    border: 't-border-red-300',
  },
  {
    key: 'digestion',
    label: t(BoomTagDigestion),
    icon: Digestion,
    bg: 't-bg-emerald-100',
    border: 't-border-emerald-300',
  },
  { key: 'sachet', label: t(BoomTagSachet), bg: 't-bg-yellow-100', border: 't-border-yellow-300' },
  { key: 'consistency', label: t(BoomTagConsistency), bg: 't-bg-teal-100', border: 't-border-teal-300' },
];

const BoomTestimonials = ({ titleClassName = 't-text-[24px] md:t-text-[30px] t-text-center' }) => {
  const { t } = useTranslation();
  const TAG_CONFIG = getTagConfig(t);
  const scrollRef = useRef(null);
  const isScrollingRef = useRef(false);
  const singleSetWidthRef = useRef(0);

  const BASE_DATA = [
    {
      name: t(BoomTestimonial8Name),
      review: t(BoomTestimonial8Review),
      type: 'video',
      file: `${process.env.REACT_APP_PUBLIC_URL}resources/videos/Testimonials+/8.mp4`,
      preview: Preview8,
      tags: ['energy', 'sleep'],
    },
    {
      name: t(BoomTestimonial9Name),
      review: t(BoomTestimonial9Review),
      type: 'video',
      file: `${process.env.REACT_APP_PUBLIC_URL}resources/videos/Testimonials+/10.mp4`,
      tags: ['sachet'],
    },
    {
      name: t(BoomTestimonial3Name),
      review: t(BoomTestimonial3Review),
      type: 'video',
      file: `${process.env.REACT_APP_PUBLIC_URL}resources/videos/Testimonials+/3.mp4`,
      preview: Preview3,
      tags: ['sports', 'recovery'],
    },
    {
      name: t(BoomTestimonial10Name),
      review: t(BoomTestimonial10Review),
      type: 'video',
      file: `${process.env.REACT_APP_PUBLIC_URL}resources/videos/Testimonials+/9.mp4`,
      tags: ['consistency'],
    },
    {
      name: t(BoomTestimonial2Name),
      review: t(BoomTestimonial2Review),
      type: 'image',
      file: `${process.env.REACT_APP_PUBLIC_URL}resources/images/testimonials/2.webp`,
      tags: ['energy', 'sleep'],
    },
    {
      name: t(BoomTestimonial1Name),
      review: t(BoomTestimonial1Review),
      type: 'video',
      file: `${process.env.REACT_APP_PUBLIC_URL}resources/videos/Testimonials+/1.mp4`,
      preview: Preview1,
      tags: ['focus', 'stress'],
    },
    {
      name: t(BoomTestimonial4Name),
      review: t(BoomTestimonial4Review),
      type: 'image',
      file: `${process.env.REACT_APP_PUBLIC_URL}resources/images/testimonials/4.webp`,
      tags: ['nails', 'immunity'],
    },
    {
      name: t(BoomTestimonial5Name),
      review: t(BoomTestimonial5Review),
      type: 'image',
      file: `${process.env.REACT_APP_PUBLIC_URL}resources/images/testimonials/5.webp`,
      tags: ['energy', 'digestion'],
    },
    {
      name: t(BoomTestimonial6Name),
      review: t(BoomTestimonial6Review),
      type: 'image',
      file: FabienneImg,
      tags: ['sports', 'energy'],
    },
  ];

  const DATA = [...BASE_DATA, ...BASE_DATA, ...BASE_DATA];

  const updateScrollState = () => {
    const el = scrollRef.current;
    if (!el || isScrollingRef.current || singleSetWidthRef.current === 0) return;

    const singleSetWidth = singleSetWidthRef.current;
    const scrollLeft = el.scrollLeft;
    const clientWidth = el.clientWidth;

    if (scrollLeft >= singleSetWidth * 2 - clientWidth / 2) {
      isScrollingRef.current = true;
      el.scrollLeft = singleSetWidth + (scrollLeft - singleSetWidth * 2);
      setTimeout(() => {
        isScrollingRef.current = false;
      }, 50);
    } else if (scrollLeft <= singleSetWidth / 2) {
      isScrollingRef.current = true;
      el.scrollLeft = singleSetWidth * 2 - (singleSetWidth - scrollLeft);
      setTimeout(() => {
        isScrollingRef.current = false;
      }, 50);
    }
  };

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    const calculateSetWidth = () => {
      const firstCard = el.querySelector('[data-card-index="0"]');
      const lastCard = el.querySelector(`[data-card-index="${BASE_DATA.length - 1}"]`);

      if (firstCard && lastCard) {
        const firstRect = firstCard.getBoundingClientRect();
        const lastRect = lastCard.getBoundingClientRect();
        singleSetWidthRef.current = lastRect.right - firstRect.left + 16;
      } else {
        singleSetWidthRef.current = BASE_DATA.length * 266;
      }

      const startPosition = singleSetWidthRef.current;
      el.scrollLeft = startPosition;
    };

    const timeoutId = setTimeout(calculateSetWidth, 100);

    const handleResize = () => {
      calculateSetWidth();
    };
    window.addEventListener('resize', handleResize);

    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener('resize', handleResize);
    };
  }, [BASE_DATA.length]);

  const scrollByAmount = (amount) => {
    scrollRef.current?.scrollBy({
      left: amount,
      behavior: 'smooth',
    });
  };

  return (
    <div className="t-flex t-flex-col t-gap-4">
      <h2 className={`!t-m-0 t-font-serif t-font-normal t-text-navy ${titleClassName}`}>{t(RoutineStick)}</h2>

      <div className="t-relative">
        <div
          ref={scrollRef}
          onScroll={updateScrollState}
          className="t-flex t-items-start t-gap-4 t-w-full t-overflow-x-auto hide-scrollbar"
        >
          {DATA.map((item, index) => (
            <Card
              {...item}
              key={'boom-testimonial-' + index}
              cardIndex={index % BASE_DATA.length}
              tagConfig={TAG_CONFIG}
            />
          ))}
        </div>

        {/* Left arrow */}
        <Icon
          name="chevronLeft"
          onClick={() => scrollByAmount(-260)}
          className="t-absolute -t-left-0 t-top-[35%] t-rounded-[0_8px_8px_0] t-p-1 t-w-8 t-h-8 t-z-10 t-bg-white t-text-navy t-shadow-sm t-border t-border-g200 hover:t-bg-g100 t-transition-colors t-cursor-pointer"
        />
        <Icon
          name="chevronRight"
          onClick={() => scrollByAmount(260)}
          className="t-absolute -t-right-0 t-top-[35%] t-rounded-[8px_0_0_8px] t-p-1 t-w-8 t-h-8 t-z-10 t-bg-white t-text-navy t-shadow-sm t-border t-border-g200 hover:t-bg-g100 t-transition-colors t-cursor-pointer"
        />
      </div>
    </div>
  );
};

const Card = ({ file, name, review, type, preview, cardIndex, tags = [], tagConfig = [] }) => {
  const tagItems = tags.map((key) => tagConfig.find((t) => t.key === key)).filter(Boolean);

  return (
    <div className="t-flex-none t-w-[220px] t-flex t-flex-col t-gap-2" data-card-index={cardIndex}>
      {type === 'video' ? (
        <video
          controls
          className="t-w-full t-object-cover t-h-[320px] t-rounded-xl t-border t-border-g200"
          poster={preview}
          playsInline
          preload={preview ? 'none' : 'metadata'}
        >
          {/* .MOV: omit type — declaring video/quicktime makes Chrome skip the source
              even though it can decode the file. Undeclared lets the browser sniff it. */}
          {/* No poster (e.g. Karin/Janine): append #t=0.1 so mobile Safari renders the
              first frame instead of a blank box. Cards with a poster are left untouched. */}
          <source src={preview ? file : `${file}#t=0.1`} type={/\.mov$/i.test(file) ? undefined : 'video/mp4'} />
        </video>
      ) : (
        <img
          src={file}
          alt=""
          className="t-w-full t-object-cover t-h-[320px] t-rounded-xl t-border t-border-g200"
        />
      )}

      <h3 className="t-font-sans t-text-[14px] t-font-semibold t-text-navy t-text-center !t-m-0">{name}</h3>
      <p className="t-font-sans t-text-[13px] t-text-navy/60 !t-m-0 t-text-center t-leading-snug">{review}</p>

      {tagItems.length > 0 && (
        <div className="t-flex t-flex-wrap t-gap-1 t-justify-center t-mt-auto">
          {tagItems.map((tag) => (
            <span
              key={tag.key}
              className={`t-inline-flex t-items-center t-gap-1 t-px-2 t-py-0.5 t-rounded-full t-border t-font-sans t-text-[11px] t-font-medium t-text-navy/70 ${tag.bg} ${tag.border}`}
            >
              {tag.icon && <img src={tag.icon} alt="" className="t-w-3 t-h-3 t-flex-shrink-0" />}
              {tag.label}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default BoomTestimonials;
